<template>
  <div class="FormBlock" :class="[{ hasError: !!errors.length }, align]">
    <div class="wrapper">
      <span v-if="label" class="label" :style="{ width: labelWidth }">
        <label class="labelText" :for="labelFor">
          {{ label }}
        </label>
        <span v-if="required" class="labelRequired"> ＊ </span>
      </span>
      <div class="contentWrapper" :style="{ width: contentWidth }">
        <div class="content">
          <slot />
        </div>
      </div>
    </div>

    <span v-if="remarks" class="remarks">
      {{ remarks }}
    </span>

    <ul v-if="errors.length" class="errors">
      <li v-for="error in errors" :key="error" class="error">
        <ErrorText :text="error" />
      </li>
    </ul>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import ErrorText from "../ErrorText";
import { Error } from "@ka-nabellinc/ka-nabell-icons";

export default defineComponent({
  components: {
    ErrorText,
    Error,
  },
  props: {
    label: {
      type: String,
      default: "",
    },
    remarks: {
      type: String,
      default: "",
    },
    required: {
      type: Boolean,
      default: false,
    },
    labelWidth: {
      type: String,
      default: "144px",
    },
    contentWidth: {
      type: String,
      default: "343px",
    },
    errors: {
      type: Array as () => string[],
      default: () => [],
    },
    labelFor: {
      type: String,
      default: "",
    },
    align: {
      type: String as () => "vertical" | "horizontal",
      default: "vertical",
    },
  },
});
</script>

<style scoped>
.FormBlock {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  width: 100%;
}

.wrapper {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.FormBlock.horizontal .wrapper {
  flex-direction: row;
  align-items: center;
}

.label {
  display: flex;
  align-items: flex-start;
  align-self: stretch;
  flex-shrink: 0;
}

.FormBlock.FormBlock.horizontal .label {
  align-self: center;
}

.labelText {
  font-size: 13px;
  font-weight: 700;
  line-height: 150%;
  letter-spacing: 0.13px;
}

.labelRequired {
  color: var(--primitive-colors-system-red-500);
  font-size: 10px;
  font-weight: 700;
  line-height: 120%;
  letter-spacing: 0.1px;
}

.contentWrapper {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.content {
  display: flex;
  align-items: center;
  gap: 8px;
}

.remarks {
  font-size: 10px;
  font-weight: 400;
  line-height: 160%;
  letter-spacing: 0.1px;
  color: var(--primitive-colors-neutral-black-500);
}

.error {
  list-style: none;
}

.errors {
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.hasError:deep(select),
.hasError:deep(input),
.hasError:deep(input:active),
.hasError:deep(input:focus),
.hasError:deep(textarea),
.hasError:deep(textarea:active),
.hasError:deep(textarea:focus) {
  border: solid 1px var(--semantic-colors-border-error);
}
</style>
